import moment from 'moment';

const isExtraSmallWindows = el => window.innerWidth < 768; // (BOOTSTAP BREAKPOINT FOR XS)
const isSmallWindows = el => window.innerWidth < 992; // (BOOTSTAP BREAKPOINT FOR SM)

// objArray
const calculateNewPosition = (objArray, index) => {
  let position = 0;

  try {
    const topPosition = objArray[index - 1]
      ? objArray[index - 1].position
      : undefined;
    const downPosition = objArray.length >= index + 2 ? objArray[index + 1].position : undefined;

    if (topPosition !== undefined && downPosition !== undefined) {
      position = (Number(topPosition) + Number(downPosition)) / 2.0;
    } else if (topPosition !== undefined) {
      position = Number(topPosition) - 0.01;
    } else if (downPosition !== undefined) {
      position = Number(downPosition) + 0.01;
    }
  } catch (e) {
    console.log(e);
  }

  return position;
};

const isUUID4 = (id) => {
  if (typeof id === 'string') {
    return !!id.match(
      /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    );
  }
  return false;
};

const isDevEnvironment = () => !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

const safeMomentDate = (date) => {
  const result = moment(date);
  if (result.isValid()) {
    return result;
  }
  return undefined;
};

function setIgHeaderSection(section) {
  document.getElementById('tool-watermark-header').innerText = section;
}

export {
  isExtraSmallWindows,
  isSmallWindows,
  calculateNewPosition,
  isUUID4,
  isDevEnvironment,
  safeMomentDate,
  setIgHeaderSection,
};
